export default __webpack_public_path__ + "static/media/solarp4.b5ad4204.jpg";